<div class="footer" [class.bg-gray]="bg">
    <p>All rights reserved. PwC refers to the PwC network and/or one or more of its member firms, each of which is a separate legal entity. Please see <a href="http://www.pwc.com/structure" target="_blank">www.pwc.com/structure</a> for further details.</p>
</div>